import { BaseEntity } from '../../models';

export class ClassificacaoFaturamento implements BaseEntity {
    readonly id: number;
    idEmpresa: number;
    nome: string;
    valorFaturamentoMensalInicial: number;
    valorFaturamentoMensalFinal: number;
    valorFaturamentoAnualInicial: number;
    valorFaturamentoAnualFinal: number;

    /** Valor Padrão para preencher automaticamente o valor do RAP (Receita Anual Pretendida) nos lançamentos das análises de mercados */
    valorPadraoRAP: number;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;
}
